/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const getPastDueData = params => {

    const pastDueData = formatGivenDate( ( params.data.pastDue ), 'YYYY-MM-DD' );

    if ( pastDueData === '' ) return ( <span>{pastDueData}</span> );
    if ( pastDueData === '2001-01-01' ) {

        return 'Inventory';

    } if ( pastDueData === '2001-02-01' ) {

        return 'Rework';

    }
    return pastDueData;

};

const colDefs = [
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 120,
        cellRenderer: params => ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.data.orderNumber}`}>{params.value}</Link> )
    },
    {
        headerName: 'RSD',
        sortable: false,
        filter: false,
        width: 100,
        valueGetter: getPastDueData
    },
    {
        field: 'family',
        headerName: 'Family',
        sortable: true,
        filter: true,
        width: 110
    },
    {
        field: 'shipMode',
        headerName: 'Ship Mode',
        sortable: true,
        filter: true,
        width: 110
    },
    {
        field: 'creditCode',
        headerName: 'Credit Code',
        sortable: true,
        filter: true,
        width: 110
    }
];

export const PastDueShipmentsTable = props => (

    <section className="atp-search-result-panel past-due-shipments-result-panel ">

        <div className="results-message">
            {`Results as of ${new Date()}`}
        </div>
        <div className="results-message">
            {`${props.totalPastDueShipmentsRows} records in Past Due Dates.`}
        </div>
        <div className="results-message">
            {`${props.totalAttachPastDueShipmentsRows} records in Attachment Past Due Dates.`}
        </div>
        {props.totalPastDueShipmentsRows > 0 && (
            <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                <AgGridReactComponent
                    reactNext={true}
                    columnDefs={colDefs}
                    rowData={props.results}
                    onGridReady={onGridReady}
                />
            </div>
        )}

    </section>
);

PastDueShipmentsTable.propTypes = {
    results: PropTypes.array.isRequired,
    totalPastDueShipmentsRows: PropTypes.number,
    totalAttachPastDueShipmentsRows: PropTypes.number
};

export const AttachmentPastDueShipmentsTable = props => (

    <section className="atp-search-result-panel past-due-shipments-result-panel ">

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

AttachmentPastDueShipmentsTable.propTypes = {
    results: PropTypes.array.isRequired
};
